const stringToSafeSlug = (text: string) => (
  text
    .replace(/\W/g, '-')
    .replace(/\s+/g, '-')
    .replace(/^-+|-+(?=-|$)/g, '')
);

export default function getProductVanityPath(vendorVariant: {
  id: number | string;
  title: string;
  vendor: {
    name?: string | null;
  };
}) {
  const slugTitle = stringToSafeSlug(vendorVariant.title);
  const slugVendor = stringToSafeSlug(vendorVariant.vendor?.name ?? '');

  return `/products/details/${slugTitle}-${slugVendor}-${vendorVariant.id}`;
}
